// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1khdk","title":"Info_title__3B0RG","links":"Info_links__3i88z","link":"Info_link__2ANw2","logo":"Info_logo__1rMB6"};